import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { HcaBookingService } from '../../../shared/_services/hca-booking.service';

@Component({
  selector: 'app-discount-points',
  templateUrl: './discount-points.component.html',
  styleUrls: ['./discount-points.component.scss']
})
export class DiscountPointsComponent implements OnInit {
  bookingIds: any[] = [];
  discountPercentage: any;
  discountPoints: any;
  constructor(
    public bsModalRef: BsModalRef,
    public hcaBookingService: HcaBookingService,
  ) { }

  confirmClose() {
    this.bsModalRef.hide();
  }
  
  getBookingDiscounts(ids) {
    this.hcaBookingService.getBookingDiscounts(ids).subscribe(res => {
      if(res.error == 0 && res.responseObj && res.responseObj.length) {
        this.discountPoints = res.responseObj;
        this.discountPercentage = res.responseObj[0].discountPercentage;
      }  else {
        this.discountPoints = [];
      }
    }, err => {
      this.discountPoints = [];
      console.error('Error while fetching discount points for booking::', err.message);
    })
  }

  ngOnInit() {
    setTimeout(() => {
      if(this.bookingIds) {
        console.log('src object for discount points list modal::', this.bookingIds);
        this.getBookingDiscounts(this.bookingIds);
      }
    }, 200);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/modals/discount-points/discount-points.component.ts